/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

/* tslint:disable:max-classes-per-file */
// tslint:disable:max-classes-per-file
import { Action } from '@ngrx/store';

export class ActionTypes {
  static RESET_STORE = '[App] Reset Store';
}

export class ResetStore implements Action {
  readonly type = ActionTypes.RESET_STORE;
}
